import React from "react";

function PreparationDelayIcon() {
  return (
    <svg
      width="55"
      height="53"
      viewBox="0 0 55 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="55" height="53" rx="20" fill="#FFBF6D" fillOpacity="0.49" />
      <path
        d="M18.2245 35.5C18.0412 35.5 17.8745 35.4543 17.7245 35.363C17.5745 35.2717 17.4579 35.1507 17.3745 35C17.2912 34.8493 17.2455 34.6867 17.2375 34.512C17.2295 34.3373 17.2752 34.1667 17.3745 34L26.6245 18C26.7245 17.8333 26.8539 17.7083 27.0125 17.625C27.1712 17.5417 27.3335 17.5 27.4995 17.5C27.6655 17.5 27.8282 17.5417 27.9875 17.625C28.1469 17.7083 28.2759 17.8333 28.3745 18L37.6245 34C37.7245 34.1667 37.7705 34.3377 37.7625 34.513C37.7545 34.6883 37.7085 34.8507 37.6245 35C37.5405 35.1493 37.4239 35.2703 37.2745 35.363C37.1252 35.4557 36.9585 35.5013 36.7745 35.5H18.2245ZM19.9495 33.5H35.0495L27.4995 20.5L19.9495 33.5ZM28.2125 32.213C28.4039 32.021 28.4995 31.7833 28.4995 31.5C28.4995 31.2167 28.4035 30.9793 28.2115 30.788C28.0195 30.5967 27.7822 30.5007 27.4995 30.5C27.2169 30.4993 26.9795 30.5953 26.7875 30.788C26.5955 30.9807 26.4995 31.218 26.4995 31.5C26.4995 31.782 26.5955 32.0197 26.7875 32.213C26.9795 32.4063 27.2169 32.502 27.4995 32.5C27.7822 32.498 28.0199 32.403 28.2125 32.213ZM28.2125 29.212C28.4039 29.0207 28.4995 28.7833 28.4995 28.5V25.5C28.4995 25.2167 28.4035 24.9793 28.2115 24.788C28.0195 24.5967 27.7822 24.5007 27.4995 24.5C27.2169 24.4993 26.9795 24.5953 26.7875 24.788C26.5955 24.9807 26.4995 25.218 26.4995 25.5V28.5C26.4995 28.7833 26.5955 29.021 26.7875 29.213C26.9795 29.405 27.2169 29.5007 27.4995 29.5C27.7822 29.4993 28.0199 29.4033 28.2125 29.212Z"
        fill="#FF7A18"
      />
    </svg>
  );
}

export default PreparationDelayIcon;
